/**
 * Removes empty fields from an object
 * @param {Object} obj - The object containing values to remove empty fields from
 * @returns {Object} A new object with empty fields removed
 */
const removeEmptyFields = (obj) => Object.fromEntries(
  Object.entries(obj).filter(([, value]) => value !== '' && value !== null && value !== undefined),
);

/**
 * Checks if any field in an object is filled
 * @param {Object} obj - The object containing values to check
 * @returns {boolean} True if any field is filled, false otherwise
 */
const isAnyFieldFilled = (obj) => Object.values(obj).some((v) => v && v.trim() !== '');

/**
 * Checks if any pricing field in an array is filled
 * @param {Array} pricingArr - The array containing pricing objects to check
 * @returns {boolean} True if any pricing field is filled, false otherwise
 */
const isAnyPricingFieldFilled = (pricingArr) => pricingArr.some(
  (item) => (item.price && item.price.trim() !== '')
    || (item.comments && item.comments.trim() !== ''),
);

/**
 * Trims all string values in an object while preserving non-string values
 * @param {Object} obj - The object containing values to trim
 * @returns {Object} A new object with trimmed string values
 */
const trimObjectValues = (obj) => Object.fromEntries(
  Object.entries(obj).map(([key, value]) => [
    key,
    typeof value === 'string' ? value.trim() : value,
  ]),
);

/**
 * Trims all string values in objects of an array
 * @param {Array} arr - The array containing objects with values to trim
 * @returns {Array} A new array with objects containing trimmed string values
 */
const trimArrayWithObjectValues = (arr) => arr.map((item) => trimObjectValues(item));

export {
  removeEmptyFields,
  isAnyFieldFilled,
  isAnyPricingFieldFilled,
  trimObjectValues,
  trimArrayWithObjectValues,
};
